import { useEffect, useRef } from 'react';
import { setGsiCredentialHandler } from '../../lib/gsiCredentialBridge';
import { ensureGsiInitialized, loadGoogleIdentityScript } from '../../lib/loadGoogleIdentityScript';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

/**
 * Renders the Google "Continue with Google" button via Identity Services.
 */
function GoogleSignInButton({ onCredential, onError }) {
  const containerRef = useRef(null);
  const onCredentialRef = useRef(onCredential);
  const onErrorRef = useRef(onError);

  onCredentialRef.current = onCredential;
  onErrorRef.current = onError;

  useEffect(() => {
    if (!CLIENT_ID) {
      return undefined;
    }

    const el = containerRef.current;
    if (!el) {
      return undefined;
    }

    let cancelled = false;
    el.innerHTML = '';
    setGsiCredentialHandler((credential) => onCredentialRef.current(credential));

    /**
     * Loads GSI and paints the button into the container.
     */
    async function mountButton() {
      try {
        await loadGoogleIdentityScript();
        if (cancelled) {
          return;
        }
        const host = containerRef.current;
        const gsi = window.google?.accounts?.id;
        if (!host || !gsi) {
          onErrorRef.current();
          return;
        }
        ensureGsiInitialized(CLIENT_ID);
        gsi.renderButton(host, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          shape: 'pill',
          width: 400,
        });
      } catch {
        onErrorRef.current();
      }
    }

    mountButton();

    return () => {
      cancelled = true;
      el.innerHTML = '';
      setGsiCredentialHandler(() => {});
    };
  }, []);

  if (!CLIENT_ID) {
    return null;
  }

  return <div ref={containerRef} className="google-signin-wrap" />;
}

export default GoogleSignInButton;
